import { createContext, useContext, useState } from 'react'
import { WallyChatLauncher } from '@wallyhealth/wally-widget-react'
import { getEnvType } from 'config'

const ChatContext = createContext({
  open: () => {},
  close: () => {}
})

export const useChat = () => useContext(ChatContext)

export const ChatProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <ChatContext.Provider
      value={{
        open: () => setIsOpen(true),
        close: () => setIsOpen(false)
      }}>
      {children}
      <WallyChatLauncher
        environment={getEnvType() === 'PROD' ? 'prod' : 'stage'}
        title="Wally"
        open={isOpen}
        onOpenChange={setIsOpen}
      />
    </ChatContext.Provider>
  )
}

export default ChatProvider
